<div class="container">
  <div class="box-form">
    <form [formGroup]="pwdRequestForm">
      <div *ngIf="status === states.start" class="content">
        <p class="header">RECUPERAR O SOLICITAR CLAVE</p>
        <p class="note">Ingrese los siguientes datos</p>
        <app-form-input-text
          label="Rut"
          [messageError]="
            username.dirty || username.touched
              ? getErrorMessage(pwdRequestForm, 'username')
              : null
          "
          formControlName="username"
          (lostFocus)="lostFocus()"
        >
        </app-form-input-text>

        <app-form-input-date
          label="Fecha de Nacimiento"
          [max]="fechaMax"
          formControlName="fn"
          [messageError]="
            fn.touched ? getErrorMessage(pwdRequestForm, 'fn') : ''
          "
        ></app-form-input-date>

        <app-button
          (clickEvent)="requestPassword()"
          classCustom="background"
          title="Siguiente"
        ></app-button>

        <div class="link">
          <a (click)="goToLogin()">Volver</a>
        </div>
      </div>
      <div *ngIf="status === states.fnSuccess" class="content">
        <p class="header success-color">GENERACIÓN DE CLAVE EXITOSA</p>
        <p class="note">
          <svg-icon
            src="../../../../assets/icons/unlock.svg"
            [stretch]="true"
            [svgStyle]="{
              'height.rem': 1.7,
              fill: '#25a39a',
              padding: 0,
              margin: 0
            }"
          ></svg-icon>
          Estimado cliente,
        </p>
        <p class="note">
          En unos minutos más, recibirá su nueva clave de acceso en su correo
          registrado:
        </p>
        <p class="email">{{ displayEmail }}</p>
        <p class="note">
          Si no reconoce esta dirección o desea actualizarla, agradeceremos se
          comunique con <strong>Servicio al Cliente</strong> llamando al
          <strong>800 222 100</strong>
        </p>
      </div>
      <div *ngIf="status === states.error" class="content">
        <p class="header error-color">ERROR AL RECUPERAR SU CLAVE</p>
        <p class="note">
          <svg-icon
            src="../../../../assets/icons/unlock.svg"
            [stretch]="true"
            [svgStyle]="{
              'height.rem': 1.7,
              fill: '#ef3e42',
              padding: 0,
              margin: 0,
              marginRight: '-0.5em'
            }"
          ></svg-icon>
          Estimado cliente,
        </p>
        <p class="note">
          Tus datos no coinciden con nuestros registros, por favor comunícate
          con <strong>Servicio al Cliente</strong> a través del
          <strong>800 222 100</strong> o escríbenos a
          <a class="email" href="contactovida@security.cl"
            >contactovida@security.cl</a
          >
        </p>
      </div>
    </form>
  </div>
  <div class="row-3"></div>
</div>
